import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal, staggerContainer, staggerItem } from "@/lib/motion";
import { WHY_CHOOSE } from "@/data/content";

export default function WhyChoose() {
  return (
    <section id="why-choose" data-testid="why-choose" className="bg-brand-ink py-24 lg:py-32 relative overflow-hidden">
      <div className="grain" />
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand-greenLight mb-4">Why Choose Us</p>
          <h2 className="font-heading font-bold text-brand-cream tracking-tight text-3xl sm:text-5xl max-w-2xl leading-[1.05]">
            Eight reasons farmers trust ADK SOLUTIONS.
          </h2>
        </Reveal>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid gap-px bg-brand-cream/10 border border-brand-cream/10 rounded-2xl overflow-hidden sm:grid-cols-2 lg:grid-cols-4"
        >
          {WHY_CHOOSE.map((item) => {
            const Icon = Icons[item.icon] || Icons.Check;
            return (
              <motion.div
                key={item.title}
                variants={staggerItem}
                data-testid={`why-${item.icon}`}
                className="group bg-brand-ink hover:bg-brand-greenDark transition-colors p-7 min-h-[190px] flex flex-col"
              >
                <span className="grid place-items-center size-11 rounded-lg bg-brand-cream/10 text-brand-greenLight group-hover:bg-brand-cream group-hover:text-brand-greenDark transition-colors mb-5">
                  <Icon className="size-5" />
                </span>
                <h3 className="font-heading font-bold text-brand-cream text-lg tracking-tight">{item.title}</h3>
                <p className="mt-2 text-sm text-brand-cream/60 leading-relaxed">{item.desc}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
